<template>
    <ModalConfirm
        id="modal-confirm-pengembalian-kas-kecil"
        title="Konfirmasi Proses Pengembalian"
        :desc="desc"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-pengembalian",
    props: {
        desc: { type: String, default: "" },
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
